import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';
import {
  SearchGeneralMasterRequest,
  DetailGeneralMasterRequest,
  UpdateGeneralMasterRequest,
  SearchGeneralMasterRecord,
  SearchGeneralMasterResponse,
  DetailGeneralMasterResponse,
  GeneralKbnRecordListResponse,
} from 'api-types/src/types/general-master';

type GeneralMasterState = {
  loading: boolean;
  loadingExportExcel: boolean;
  filterSearchTotal: number;
  filterInitialSearchData: SearchGeneralMasterRecord[];
  filterSearchData: SearchGeneralMasterRecord[];
  sortSelected: string;
  sortDirection: string;
  message: string;
  generalDetail: DetailGeneralMasterResponse | {};
  success: boolean;
  generalKbn: GeneralKbnRecordListResponse;
};

const initialState: GeneralMasterState = {
  loading: false,
  loadingExportExcel: false,
  filterSearchTotal: 0,
  filterInitialSearchData: [],
  filterSearchData: [],
  sortSelected: '',
  sortDirection: '',
  message: '',
  generalDetail: {},
  success: false,
  generalKbn: [],
};

export const generalMasterSlice = createSlice({
  name: 'generalMaster',
  initialState,
  reducers: {
    filterGeneral: (state, action: { payload: SearchGeneralMasterRequest }) => {
      state.loading = true;
      state.message = '';
    },
    filterGeneralSuccess: (state, action: { payload: SearchGeneralMasterResponse }) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload?.records;
      state.filterSearchData = action.payload?.records;
      if (!action.payload?.total) {
        state.message = i18n.t('message.common.0001');
      }
      state.filterSearchTotal = action.payload?.total;
      state.success = false;
    },
    filterGeneralFailure: (state) => {
      state.loading = false;
    },
    getKbnGeneral: (state) => {
      state.loading = true;
    },
    getKbnGeneralSuccess: (state, action: { payload: GeneralKbnRecordListResponse }) => {
      state.loading = false;
      state.generalKbn = action.payload;
    },
    getDetailGeneral: (state, action: { payload: DetailGeneralMasterRequest }) => {
      state.loading = true;
    },
    getDetailGeneralSuccess: (state, action: { payload: DetailGeneralMasterResponse }) => {
      state.loading = false;
      state.generalDetail = action.payload;
    },
    getDetailGeneralFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    setLoadingExportExcel: (state, action: { payload: boolean }) => {
      state.loadingExportExcel = action.payload;
    },
    registerGeneral: (state, action: { payload: UpdateGeneralMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    registerGeneralSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    registerGeneralFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    updateGeneral: (state, action: { payload: UpdateGeneralMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    updateGeneralSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    updateGeneralFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    cleanDataGeneral: (state) => {
      state.generalDetail = {};
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  filterGeneral,
  filterGeneralSuccess,
  filterGeneralFailure,
  getKbnGeneral,
  getKbnGeneralSuccess,
  getDetailGeneral,
  getDetailGeneralSuccess,
  getDetailGeneralFailure,
  setLoadingExportExcel,
  registerGeneral,
  registerGeneralSuccess,
  registerGeneralFailure,
  updateGeneral,
  updateGeneralSuccess,
  updateGeneralFailure,
  cleanDataGeneral,
  cleanData,
} = generalMasterSlice.actions;

export default generalMasterSlice.reducer;
